"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Metadata = _interopRequireDefault(require("./Metadata"));

var _ClampLines = _interopRequireDefault(require("@insided/shared/uikit/ClampLines"));

var _common = require("@insided/shared/utils/common");

var eventTracker = function eventTracker(item) {
  _publish.default.trackEvent('userevent', {
    type: 'Category Clicked',
    category_title: item.title,
    category_url: item.url,
    category_type: 'category',
    click_source: 'parent category'
  });
};

var CategoryListItem = function CategoryListItem(props) {
  var key = props.key,
      title = props.title,
      url = props.url,
      categoriesCount = props.categoriesCount,
      visibleTopicsCount = props.visibleTopicsCount,
      isContainer = props.isContainer,
      showMetadata = props.showMetadata,
      thumbnailImage = props.thumbnailImage,
      cdn = props.cdn;
  var showThumbnail = _common.common.isModuleActive('categoryThumbnails') && thumbnailImage && cdn;
  return (0, _preact.h)("li", {
    className: "category-page_list-item card-widget-wrapper",
    key: key
  }, (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(url),
    className: (0, _classnames.default)('category-page_list-item-link', 'link', 'card-widget-title', {
      'category-page_list-item-link--with-thumbnail': showThumbnail
    }),
    onClick: function onClick() {
      return eventTracker({
        title: title,
        url: url
      });
    }
  }, showThumbnail && (0, _preact.h)("img", {
    src: (0, _absoluteUrlRuntime.resolveUrl)("".concat(cdn).concat(thumbnailImage)),
    alt: "",
    className: "category-page_list-item-thumbnail" // @ts-expect-error - loading attribute is valid HTML but not in Preact types
    ,
    loading: "lazy"
  }), (0, _preact.h)("span", null, (0, _preact.h)(_ClampLines.default, {
    id: "category-list-item",
    lines: 2,
    text: title || ''
  }), showMetadata && (0, _preact.h)(_Metadata.default, {
    categoriesCount: categoriesCount,
    visibleTopicsCount: visibleTopicsCount,
    isContainer: isContainer
  })), (0, _preact.h)("i", {
    className: "icon icon--caret-right"
  })));
};

var _default = CategoryListItem;
exports.default = _default;